// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2KkOk","label":"Section_label__2b7Fs","contentWrap":"Section_contentWrap__145_a","footer":"Section_footer__3AvH0","footerInner":"Section_footerInner__3wD8e"};